'use client';

export default function IconClose(props: any) {
    return (
        <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="会员体系" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="券-弹框" transform="translate(-1248.000000, -119.000000)" stroke="#03060B">
                    <g
                        id="编组备份-9"
                        transform="translate(1264.000000, 135.000000) scale(-1, 1) translate(-1264.000000, -135.000000) translate(1248.000000, 119.000000)"
                    >
                        <circle id="椭圆形备份-3" strokeWidth="1.6" cx="16" cy="16" r="15.2"></circle>
                        <g id="编组" transform="translate(10.909091, 10.909091)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.44">
                            <line x1="10.1818182" y1="0" x2="0" y2="10.1818182" id="路径-2"></line>
                            <line x1="10.1818182" y1="10.1818182" x2="0" y2="0" id="路径-2"></line>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
